import { createContext, useContext, useEffect, useState } from "react";
import { api, imgUrl } from "../lib/api";
import { STRINGS } from "../lib/translations";

const SiteContext = createContext({ settings: {}, services: [], user: null, setUser: () => {} });

export function SiteProvider({ children }) {
  const [settings, setSettings] = useState({});
  const [services, setServices] = useState([]);
  const [user, setUser] = useState(undefined);
  const [lang, setLangState] = useState(() => localStorage.getItem("lang") || "en");

  const setLang = (l) => {
    setLangState(l);
    localStorage.setItem("lang", l);
    document.documentElement.lang = l;
  };

  const L = STRINGS[lang];

  useEffect(() => {
    api.get("/settings").then((r) => setSettings(r.data || {})).catch(() => {});
    api.get("/services").then((r) => setServices(r.data || [])).catch(() => {});
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(null));
  }, []);

  useEffect(() => {
    if (settings.logo_url) {
      let link = document.querySelector("link[rel='icon']");
      if (!link) {
        link = document.createElement("link");
        link.rel = "icon";
        document.head.appendChild(link);
      }
      link.href = imgUrl(settings.logo_url);
    }
  }, [settings.logo_url]);

  useEffect(() => {
    if (settings.ga4_measurement_id && !window.gtag) {
      const s = document.createElement("script");
      s.src = `https://www.googletagmanager.com/gtag/js?id=${settings.ga4_measurement_id}`;
      s.async = true;
      document.head.appendChild(s);
      window.dataLayer = window.dataLayer || [];
      window.gtag = function () { window.dataLayer.push(arguments); };
      window.gtag("js", new Date());
      window.gtag("config", settings.ga4_measurement_id);
    }
  }, [settings.ga4_measurement_id]);

  useEffect(() => {
    const sameAs = [settings.facebook_url, settings.nextdoor_url, settings.google_business_url].filter(Boolean);
    const script = document.querySelector('script[type="application/ld+json"]');
    if (script) {
      try {
        const data = JSON.parse(script.textContent);
        if (sameAs.length) data.sameAs = sameAs; else delete data.sameAs;
        script.textContent = JSON.stringify(data);
      } catch {}
    }
  }, [settings.facebook_url, settings.nextdoor_url, settings.google_business_url]);

  return (
    <SiteContext.Provider value={{ settings, setSettings, services, user, setUser, lang, setLang, L }}>
      {children}
    </SiteContext.Provider>
  );
}

export const useSite = () => useContext(SiteContext);
